const SOLVPATH_URL = 'https://solvpath.com'

const OmpFooter = () => {
  return (
    <footer className="omp-footer">
      <div className="omp-container">
        <div className="omp-layout-grid omp-footer-grid">
          <div className="omp-nav-col" aria-hidden="true" />
          <div className="omp-content-col">
            <a className="powered-by-solvpath omp-footer-link" href={SOLVPATH_URL} target="_blank" rel="noreferrer">
              <span>Powered by</span>
              <img src="/assets/images/solvpath-logo.svg" alt="SolvPath" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default OmpFooter
